import OkTableConfigType from '@/@bya3/components/tables/ok-table/OkTableConfigType'
import { API_URL } from '@/constants/config'

const PostsTableConfig: OkTableConfigType = {
  mode: 'remote',
  url: `${API_URL}/pages/posts`,
  rowsPath: 'posts',
  rowClickable: true,
  attachPageId: true,
  columns: [
    {
      label: 'reply.post',
      field: 'image',
    },
    {
      label: 'reply.post',
      field: 'post',
    },
    {
      label: 'fields.created-at',
      field: 'created_time',
    },
    {
      label: 'forms.actions',
      field: 'actions',
    },
  ],
  paginationOptions: {
    enabled: false,
    perPage: 100,
    perPageOptions: [50, 100],
  },
  sortOptions: {
    enabled: false,
  },
  actions: [
  ],
  filters: [
  ],
}

export default PostsTableConfig
